module.exports = __webpack_public_path__ + "img/pianxinlun.prt.6f4220b6.jpg";